// extracted by mini-css-extract-plugin
module.exports = {"card__container":"index_card__container_20sEI","card__top":"index_card__top_1hS1R","card__top__basic":"index_card__top__basic_1EnLb","card__footer":"index_card__footer_c-kKf"};